<template>
  <div class="container">
    <div class="company inner">
      <div class="posite">
        <ul class="posite-menu"></ul>
         <div class="posite-map posite-map1">
          <span><i class="iconfont">&#xe65e;</i>当前位置：</span>
          <router-link to="/">首页</router-link>
          <b>></b>
           <router-link to="/jzabout">关于我们</router-link>
          <b>></b>
          <span>{{activeNmaes}}</span>
        </div>
      </div>
      <div class="company-fixe">
        <div class="company-btn">
          <div class="company-btnItem" :class="{'active': activeIndex == index}" v-for="(item, index) in taskDatalist" @click="companyTab(index)" :key="item.cid">
            <a href="javascript:;">{{item.title}}</a>
          </div>
        </div>
        <div class="company-tabs">
          <!-- <div class="company-tabs-item" v-for="(item, index) in targeData" :key="item.cid" :id="['task'+ (index+1)]" v-show="activeIndex == index">
            <div class="company-info">
              <p v-html="item.description"></p>
            </div>
          </div> -->
          <div class="company-tabs-item" v-show="activeIndex == 0">
            <div class="compnay-title">
              <strong>{{taskDatalist[0].title}}</strong>
              <p>{{taskDatalist[0].description}}</p>
            </div>
            <div class="guide" v-html="taskDatalist[0].content"></div>
          </div>
          <div class="company-tabs-item" v-show="activeIndex == 1">
            <div class="compnay-title">
              <strong>{{taskDatalist[1].title}}</strong>
              <p>{{taskDatalist[1].description}}</p>
            </div>
            <div class="goal" v-html="taskDatalist[1].content">
            </div>
          </div>
          <div class="company-tabs-item" v-show="activeIndex == 2">
            <div class="compnay-title">
              <strong>{{taskDatalist[2].title}}</strong>
              <p>{{taskDatalist[2].description}}</p>
            </div>
            <div class="goal" v-html="taskDatalist[2].content">
            </div>
          </div>
          <div class="company-tabs-item" v-show="activeIndex == 3">
            <div class="compnay-title">
              <strong>{{taskDatalist[3].title}}</strong>
              <p>{{taskDatalist[3].description}}</p>
            </div>
            <div class="goal" v-html="taskDatalist[3].content">
            </div>
          </div>
          <!-- <div class="company-tabs-item" v-show="activeIndex == 1">
            <div class="compnay-title">
              <strong>总体目标</strong>
            </div>
            <div class="goal">
              <p>整合集聚国内高端创新资源，构建“医政产学研资用”协同创新生态系统</p>
              <p>建设精准诊断、精准治疗、精准评价等关键共性技术平台和精准医学战略资源库支撑平台，形成基础研究和应用基础研究原创性成果</p>
              <p>联合行业企业共同研发转化关键核心技术，促进相关技术产品在肿瘤、感染性疾病、罕见病、遗传病等疑难疾病和慢病防诊治中的临床应用</p>
              <p>培育具有全球竞争力的世界一流企业，推动我国精准医学产业在全球竞争中占据领先地位</p>
              <br>
              <img src="../../assets/img/51.png" alt=""/>
            </div>
          </div>
          <div class="company-tabs-item" v-show="activeIndex == 2">
            <div class="compnay-title">
              <strong>中心任务</strong>
            </div>
            <div class="goal">
              <p>以国家级平台为支撑，整合“医政产学研资”的优质资源</p>
              <p>以创新研发、成果转化与产业化为目标</p>
              <p>建设精准诊断、精准治疗、精准评价和精准服务共性技术平台，攻克关键核心技术，推动创新成果转化</p>
              <p>开展知识产权运营、项目投资、企业孵化和临床研究服务</p>
              <p>组建 10 亿元规模“精准医学产业创新基金”</p>
              <p>组建不同领域方向的二级公司开展相关业务</p>
              <br>
              <img src="../../assets/img/52.png" alt=""/>
            </div>
          </div>
          <div class="company-tabs-item" v-show="activeIndex == 3">
            <div class="compnay-title">
              <strong>体制机制</strong>
            </div>
            <div class="goal">
              <img src="../../assets/img/53.png" alt=""/>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: this.title,
      meta: [{
        name: 'keyWords',
        content: this.keyWords
      },
      {
        name: 'description',
        content: this.description
      }]
    }
  },
  data () {
    return {
      compatyData: {},
      activeIndex: 0,
      targeData: {},
      activeNmaes: '建设指引',
      taskDatalist: [],
      title: '',
      keyWords: '',
      description: ''
    }
  },
  methods: {
    goAnchor (selector) {
      document.querySelector(selector).scrollIntoView({
        behavior: 'smooth'
      })
    },
    async getData () {
      const { data: res } = await this.$http.get('/fdata/article_pagelist_show?catid=86')
      const { data: res1 } = await this.$http.get('/fdata/category?catid=86')
      const { data: res2 } = await this.$http.get('/fdata/article_show?cid=171')
      const { data: res3 } = await this.$http.get('/fdata/article_show?cid=170')
      const { data: res4 } = await this.$http.get('/fdata/article_show?cid=169')
      const { data: res5 } = await this.$http.get('/fdata/article_show?cid=307')
      if (res.code === 1) {
        this.targeData = res.data.info
        this.taskDatalist.push(res2.data)
        this.taskDatalist.push(res3.data)
        this.taskDatalist.push(res4.data)
        this.taskDatalist.push(res5.data)
        this.title = res1.data[0].seotitle
        this.keyWords = res1.data[0].seokeywords
        this.description = res1.data[0].seodescription
      }
    },
    companyTab (index) {
      this.activeIndex = index
      this.activeNmaes = this.taskDatalist[this.activeIndex].title
    }
  },
  mounted () {
    this.getData()
    if (Number(this.$route.query.layIndex) > 0) {
      this.activeIndex = this.$route.query.layIndex
      setTimeout(() => {
        this.activeNmaes = this.taskDatalist[this.activeIndex].title
      }, 400)
    }
  },
  watch: {
    $route (to, from) {
      this.activeIndex = this.$route.query.layIndex
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/about/index.less");
@import url("@/assets/css/common/index.less");
</style>
